import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import InputField from "components/UI/InputField";
import toast from "react-hot-toast";
import { VideoSchema } from "validation/schema/video.schema";
import FileUpload from "components/UI/FileUpload";
import { axiosSakusas } from "common/api/axios/sakusas_axios";
import { FILE_UP_NAME } from "common/constants";

type VideoUploadProps = {
  fileUploadHandle: Function;
  fileNameDefault?: string;
};

const VideoUpload = ({
  fileUploadHandle,
  fileNameDefault,
}: VideoUploadProps) => {
  //   const onSubmit = async (data: any) => {
  //     console.log(data);

  //     toast.success("New video added");
  //   };
  //   const fileUploadHandle = (upRes: any) => {
  //     console.log("fileUploadHandle", upRes);
  //   };
  const uploadUrl = "video/up";

  return (
    <DivUpload>
      <FileUpload
        axiosInstance={axiosSakusas}
        fileFieldName={FILE_UP_NAME}
        fileUploadHandle={fileUploadHandle}
        uploadUrl={uploadUrl}
        showUploadedFile
        fileNameDefault={fileNameDefault}
      />
    </DivUpload>
  );
};

const DivUpload = styled.div`
  display: flex;
`;

export default VideoUpload;
